import { EuiButton, EuiCallOut } from "@inscopix/ideas-eui";
import { FilePreviewComponentProps } from "./FilePreview.types";
import { downloadFile } from "utils/downloadFile";
import { filesize } from "utils/filesize";

export const FilePreviewTooLarge = ({
  preview,
  size,
}: FilePreviewComponentProps & { size: number }) => {
  return (
    <EuiCallOut title="Maximum preview size exceeded" iconType="warning">
      <p>
        This preview is too large to be displayed. You can download the file
        instead.
      </p>
      <EuiButton
        color="primary"
        fill
        iconType={"download"}
        onClick={() => {
          const filename = `${preview.name}.png`;
          downloadFile(preview.url, filename);
        }}
      >
        Download ({filesize(size)})
      </EuiButton>
    </EuiCallOut>
  );
};
